import type { EntityConfig } from '../types'

export const terminalEntity: EntityConfig = {
  id: 'terminal',
  displayName: 'Terminal',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
      { value: 'offline', label: 'Offline' },
      { value: 'blocked', label: 'Blocked' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'inactive', label: 'Inactive', color: 'warning' },
      { value: 'offline', label: 'Offline', color: 'error' },
      { value: 'blocked', label: 'Blocked', color: 'error' },
    ],
    mappings: {
      all: ['active', 'inactive', 'offline', 'blocked'],
      active: ['active'],
      inactive: ['inactive'],
      offline: ['offline'],
      blocked: ['blocked'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    location: { type: 'string_array', urlKey: 'location' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'status',
    'store',
    'location',
    'type',
    'createdDate',
    'lastSeenDate',
    'blockedDate',
    'lastUpdatedDate',
  ]
}
